import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import type { Product } from '../data/products';
interface ProductCardProps {
  product: Product;
  onAddToCart: (product: Product) => void;
}
const badgeColors: Record<string, string> = {
  new: 'bg-[#2d6a4f]',
  hot: 'bg-[#c1121f]',
  limited: 'bg-[#6b4226]'
};
export function ProductCard({
  product,
  onAddToCart
}: ProductCardProps) {
  const [added, setAdded] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  function handleAdd(e: React.MouseEvent) {
    e.stopPropagation();
    if (added) return;
    onAddToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  }
  function handleImageClick(e: React.MouseEvent) {
    e.stopPropagation();
    setZoomed(true);
  }
  function handleCloseZoom(e: React.MouseEvent) {
    e.stopPropagation();
    setZoomed(false);
  }
  return <>
      <motion.div className="group relative cursor-pointer overflow-hidden bg-white" whileHover={{
      y: -4,
      boxShadow: '0 15px 30px rgba(0,0,0,0.10)'
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} onClick={handleAdd} data-id="element-103">
        {/* Badge */}
        {product.badge && <span className={`absolute left-2.5 top-2.5 z-[2] px-2 py-[3px] text-[8px] uppercase tracking-[2px] text-white ${badgeColors[product.badge]}`} data-id="element-104">
            {product.badge === 'new' ? 'New' : product.badge === 'hot' ? 'Hot' : 'Limited'}
          </span>}

        {/* Image */}
        <div className="relative h-[150px] overflow-hidden bg-[#f0ece6] md:h-[200px] cursor-zoom-in" onClick={handleImageClick} data-id="element-105">
          <img src={product.image} alt={`${product.brand} ${product.name}`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-106" />
          {/* Hover overlay */}
          <div className="absolute bottom-0 left-0 right-0 translate-y-full bg-[rgba(26,26,26,0.85)] px-3 py-2.5 text-center text-[10px] uppercase tracking-[2px] text-white transition-transform duration-300 group-hover:translate-y-0" data-id="element-107">
            + Agregar al carrito
          </div>
        </div>

        {/* Info */}
        <div className="border-t border-[#f0f0f0] px-3 py-3" data-id="element-108">
          <div className="mb-[3px] text-[9px] uppercase tracking-[2px] text-[#888]" data-id="element-109">
            {product.brand}
          </div>
          <div className="mb-1 text-[13px] font-semibold leading-tight tracking-[0.5px]" data-id="element-110">
            {product.name}
          </div>
          <div className="text-[15px] font-bold tracking-[0.5px]" data-id="element-111">
            ${product.price.toLocaleString('es-AR')}{' '}
            <span className="ml-[2px] text-[10px] font-normal text-[#888]" data-id="element-112">
              ARS
            </span>
          </div>
          <button onClick={handleAdd} className={`mt-2.5 w-full py-2.5 text-[10px] uppercase tracking-[2px] text-white transition-colors duration-300 ${added ? 'bg-[#2d6a4f]' : 'bg-[#1a1a1a] hover:bg-[#333]'}`} data-id="element-113">
            {added ? '✓ Agregado' : 'Agregar al Carrito'}
          </button>
        </div>
      </motion.div>

      {/* Fullscreen image zoom modal */}
      <AnimatePresence data-id="element-114">
        {zoomed && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 cursor-zoom-out p-4" onClick={handleCloseZoom} data-id="element-115">
            <motion.img initial={{
          scale: 0.85,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.85,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} src={product.image} alt={`${product.brand} ${product.name}`} className="max-h-[85vh] max-w-[90vw] object-contain rounded shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-116" />
            <button onClick={handleCloseZoom} className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-[20px] text-white backdrop-blur-sm transition-colors hover:bg-white/25" aria-label="Cerrar imagen" data-id="element-117">
              ✕
            </button>
          </motion.div>}
      </AnimatePresence>
    </>;
}